/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MeteredDataSourceType = {
    Meter: 'Meter',
    CalculationFormula: 'CalculationFormula',
} as const;
export type MeteredDataSourceType = typeof MeteredDataSourceType[keyof typeof MeteredDataSourceType];

